import { makeMapStateToProps, mapDispatchToProps } from "./map-to-props-factory";
import { createUniversalConnector } from "../../universal-connector-factory";
import { withSportsbookBetslipContext, type SportsbookBetslipContext } from "../../../context/sportsbook";
import { ComponentProps, StateProps, DispatchProps } from "../props";
import { CombinationContainerProps } from "./props";

export default withSportsbookBetslipContext(({ localization }: SportsbookBetslipContext) => ({
  localization,
}))(
  createUniversalConnector<StateProps, DispatchProps, CombinationContainerProps, ComponentProps>(
    makeMapStateToProps,
    mapDispatchToProps,
  ),
);
